import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "27px",
    color: "#465869",
  },
  mainContainer: {
    marginTop: "0px !important",
  },
  titleStatusBadge: {
    height: "24px !important",
    width: "fit-content !important",
    fontFamily: "Manrope",
    marginInline: "8px",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
  },
  containerInputRange: {
    marginTop: "0px !important",
  },
  nameTags: {
    marginBottom: -4,
    marginLeft: 4,
    paddingInline: 2,
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: colors.gray50,
    borderRadius: 12,

    width: "calc(100% - 30px)",
    marginLeft: 8,
    marginTop: 12,
    marginBottom: 12,
  },

  checkboxItem: {
    "&:not(:last-child)": {
      borderBottom: `1px solid ${colors.gray200}`,
    },
    padding: 16,
  },
  mt20: {
    marginTop: 20,
  },
  dflex: {
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    "& div.MuiFormControl-root": {
      flex: 1,
    },
  },
  descriptionLoading: {
    marginTop: "12px",
  },
}));

export default styles;
